import React, { useEffect, useState } from "react";
import { fetchData } from "../../Components/common/utils";
import { NavLink } from "react-router-dom";
import MainLoader from "../../Components/MainLoader";
const AllProducts = () => {
    const [mainList, setMainList] = useState([]);
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [logosByCategory, setLogosByCategory] = useState({});
    useEffect(() => {
        const fetchApiData = async () => {
            setIsLoading(true)
            const url = "api/product";
            const result = await fetchData(url);
            if (result && result.data) {
                const categorizedproduct = {};
                result.data.forEach((item) => {
                    const categoryTitle = item.category?.title;
                    if (!categorizedproduct[categoryTitle]) {
                        categorizedproduct[categoryTitle] = [];
                    }
                    categorizedproduct[categoryTitle]?.push({
                        id: item.id,
                        img: item.media[0]?.original_url,
                        name: item?.title,
                        description: item?.short_description,
                        price: item?.price,
                        slug: item?.slug
                    });
                });
               
                setMainList(result.data);
                setCategories(Object.keys(categorizedproduct));
                setLogosByCategory(categorizedproduct);
                setSelectedCategory(Object.keys(categorizedproduct)[0]);

            }
             setIsLoading(false)
        };
        fetchApiData();
    }, []);

    return (
        <>
        {isLoading && <MainLoader/>}
            <section className="buy py-5">
                <div className="container">
                    <div className="mt-4">
                        {/* Modern Header */}
                        <div className="brand-banner py-3 px-3 text-center text-white mb-4">
                            <h1 className="display-4 fw-bold ">Welcome to <span className="brand-name">EnergyBazzar Store</span></h1>
                            {/* <p className="lead">{categoryName?.description}</p> */}
                        </div>
                    </div>
                    <div className="">
                        <div className="row">
                            <div className="d-flex align-items-center flex-wrap justify-content-center gap-2 my-5">
                                {categories.map((category, index) => (
                                    <button
                                        key={index}
                                        className={`tabs-btns ${selectedCategory === category ? "active" : ""
                                            }`}
                                        onClick={() => setSelectedCategory(category)}
                                    >
                                        {category}
                                    </button>
                                ))}
                            </div>
                            {logosByCategory[selectedCategory]?.map((details, index) => (
                                <div className="col-md-3 mb-2" key={index}>
                                    <NavLink to={`/products/${details.slug}`}>
                                        <div className="card">
                                            <div className="card-img-wrapper">
                                                <img src={details?.img} alt={details?.title} />
                                            </div>
                                            <div className="card-body text-start">
                                                <h3 className="card-title text-start">{details?.title}</h3>
                                                <p className="">{details?.description}</p>
                                                <strong className="dollar">{details?.price}</strong>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default AllProducts;
